import { useNotification } from '../context/NotificationContext'
import type { NotificationType } from '../context/NotificationContext'
import { useCallback, useMemo } from 'react'

export const useNotificationActions = () => {
  const { showAlert, showToast } = useNotification()

  const topAlert = useCallback((
    message: string,
    type: NotificationType = 'success',
    duration?: number
  ) => {
    showAlert({
      type,
      message,
      position: 'top',
      ...(duration ? { duration } : {}),
    })
  }, [showAlert])

  const bottomAlert = useCallback((
    message: string,
    type: NotificationType = 'success',
    duration?: number
  ) => {
    showAlert({
      type,
      message,
      position: 'bottom',
      ...(duration ? { duration } : {}),
    })
  }, [showAlert])

  const topToast = useCallback((
    message: string,
    type: NotificationType = 'success',
    title?: string,
    duration?: number
  ) => {
    showToast({
      type,
      title: title ?? (type === 'success' ? 'Успех' : type === 'error' ? 'Ошибка' : 'Внимание'),
      message,
      position: 'top-right',
      ...(duration ? { duration } : {}),
    })
  }, [showToast])

  const bottomToast = useCallback((
    message: string,
    type: NotificationType = 'success',
    title?: string,
    duration?: number
  ) => {
    showToast({
      type,
      title: title ?? (type === 'success' ? 'Успех' : type === 'error' ? 'Ошибка' : 'Внимание'),
      message,
      position: 'bottom-right',
      ...(duration ? { duration } : {}),
    })
  }, [showToast])

  const warningAlertWithConfirm = useCallback((
    message: string,
    onConfirm: () => void,
    onCancel?: () => void,
    confirmText?: string,
    cancelText?: string,
    duration?: number,
    confirmButtonVariant?: 'primary' | 'secondary' | 'success' | 'warning' | 'danger',
    cancelButtonVariant?: 'primary' | 'secondary' | 'success' | 'warning' | 'danger',
  ) => {
    showAlert({
      type: 'primary',
      message,
      position: 'top',
      onConfirm,
      onCancel,
      confirmText,
      cancelText,
      duration: duration ?? 10000,
      confirmButtonVariant,
      cancelButtonVariant,
    })
  }, [showAlert])

  const primaryAlert = useCallback((
    message: string,
    duration?: number
  ) => {
    showAlert({
      type: 'primary',
      message,
      position: 'top',
      ...(duration ? { duration } : {}),
    })
  }, [showAlert])

  return useMemo(() => ({
    topAlert,
    bottomAlert,
    topToast,
    bottomToast,
    warningAlertWithConfirm,
    primaryAlert,
  }), [topAlert, bottomAlert, topToast, bottomToast, warningAlertWithConfirm, primaryAlert])
}
